import RestPromise from "./RestPromise";

export interface CodeValidationResponse {
  success: boolean;
  error?: string;
}

export default class FamilyCodeValidationService {
  /**
   * Validates a PIN code for a specific member
   * @param memberId - The ID of the family member (null for parent)
   * @param code - The plain text PIN code
   * @returns Promise resolving to a validation result
   */
  public async ValidateCode(
    memberId: number | null,
    code: string,
  ): Promise<CodeValidationResponse> {
    const hashedCode = await this.hashCode(code);

    return RestPromise.Create(`/rest/check-code`, "POST", {
      id: memberId,
      code: hashedCode,
    });
  }

  /**
   * Hashes a code using SHA-256
   * @param code - The plain text code to hash
   * @returns Promise resolving to the hashed code as hex string
   */
  private async hashCode(code: string): Promise<string> {
    return crypto.subtle
      .digest("SHA-256", new TextEncoder().encode(code))
      .then((buf) => {
        return Array.prototype.map
          .call(new Uint8Array(buf), (x) => ("00" + x.toString(16)).slice(-2))
          .join("");
      });
  }
}
